/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

import { LinearProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import * as UserActions from 'store/actions/user';

import SimpleLineGraphic from '../graphics/SimpleLineGraphic';

function ReceivementInfosArea({ userInfo, receivementOpenOrders }) {
  const { id: paramsID } = useParams();

  return (
    <section className="homeReceivementInfosContainer homeDefaultContainer">
      <div className="homeDefaultInfoTitle">
        <p>
          RECEBIMENTO
        </p>
      </div>

      <div className="graphicContainer">
        <div className="graphicBox">
          <div className="graphicItem">
            <span className="graphicTitle">
              pedidos em aberto
            </span>

            {receivementOpenOrders?.loading ? (
              <div className="dFlex">
                <LinearProgress className="w100 mb10" id="loading" variant="query" />
              </div>
            ) : 
              <SimpleLineGraphic 
                mainContent={receivementOpenOrders}
              />
            }
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReceivementInfosArea);
